export const Urls = {
    GetCustomReport: "customReport/GetCustomReport",
    SaveCustomReport: "customReport/SaveCustomReport",
    DeleteCustomReports: "customReport/DeleteCustomReports",
    ExportCustomReport: "customReport/ExportCustomReport"
};
